import { useHistory } from 'react-router';
import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';

// app
import { adminAxios } from '../../admin.api';
import { OPERATIONAL_CLIENTS } from '../../queryKeys';
import * as utils from 'utils';
import config from 'config';
import { logoutAuth0 } from 'utils/auth0/auth0';
import { enqueueNotification, hideModal } from 'stores';

export const useDeleteOperationalClient = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const history = useHistory();

  const handleSettled = () => {
    dispatch(hideModal());
  };

  const handleError = (err) => {
    const errorParams = {
      file: 'admin.mutations.useDeleteOperationalClient',
      message: 'Data missing for DELETE request',
    };
    utils.api.handleError(err, errorParams);
    utils.api.handleUnauthorized(err, null, logoutAuth0);
    err?.response?.data?.message
      ? dispatch(enqueueNotification(err?.response?.data?.message, 'error'))
      : dispatch(enqueueNotification('notification.admin.deleteOperationalClientFail', 'error'));
  };

  const handleSuccess = (res) => {
    const { data } = res;
    queryClient.invalidateQueries(OPERATIONAL_CLIENTS);
    history.push(config.routes.admin.operationalClients);

    dispatch(
      enqueueNotification('notification.admin.deleteOperationalClientSuccess', 'success', {
        data: { clientName: data?.name },
      })
    );
  };

  return useMutation(
    async (id) => {
      return await adminAxios.delete(`client/operational/${id}`);
    },
    {
      onSuccess: (res) => handleSuccess(res),
      onError: (err) => handleError(err),
      onSettled: handleSettled,
    }
  );
};
